import { stringSimilarity } from "string-similarity-js";

import {
  ChecklistRole,
  checklistRoleDefaultTitles,
  checklistRoles,
} from "../model/checklistAppState";

export function guessChecklistRole(checklistTitle: string): ChecklistRole {
  const scored = checklistRoles.map((r): [ChecklistRole, number] => {
    const checklistRoleDefaultTitle = checklistRoleDefaultTitles[r];
    const score = stringSimilarity(
      checklistRoleDefaultTitle.toLowerCase(),
      checklistTitle.toLowerCase()
    );
    return [r, score];
  });

  const ranked = scored.sort((a, b) => b[1] - a[1]);
  return ranked[0][0];
}
